import {headerEl} from '../helpers/utilities';

const
    headerFlyoutEl = headerEl.querySelector('[data-header-component="flyout"]'),
    headerFocusManagers = headerEl.querySelectorAll('[data-header-component="focus-manager"]');

/**
 * Attach listener to the `headerEl` element for whenever the focus is swapped within the element.
 */
export default function setupHeaderFocus() {
    headerEl.addEventListener('focusin', _headerFocusHandler);
    headerEl.addEventListener('focusout', _headerFocusHandler);
    //Ensure clicks are tracked as well, so that when user clicks outside a header panel it checks if there still are active panels.
    document.addEventListener('click', _headerFocusHandler);
}

/**
 * Handles focus management when interacting with header elements.
 * Toggles a "focus-within" class whenever an element within the header gains or loses focus.
 */
function _headerFocusHandler() {
    //Set the "focus-within" class whenever an element within the `[data-header-component="header"]` container gains focus.
    //Since focus is managed with born-megamenu and born-toggle, this takes care of ensuring the class is present when necessary.
    if (document.activeElement.closest('[data-header-component="header"]')) {
        headerEl.classList.add('focus-within');
    } else if (!_hasVisibleFocusManagers()) {
        //Remove the "focus-within" class only when there's no born-megamenu or born-toggle triggers active.
        //This prevents removing the state in case the container loses focus, i.e. if a toggle is triggered but the user clicks on its target container (which sets the focus to the `body` element).
        headerEl.classList.remove('focus-within');
    }
}

/**
 * Determines wether or not there are currently visible "panels" in the header.
 * That is, whenver there's an active born-toggle or born-megamenu, or something else that is expanded within the header.
 */
function _hasVisibleFocusManagers() {
    if (headerFlyoutEl && headerFlyoutEl.classList.contains('mega--active')) {
        return true;
    } else {
        for (let i = 0; i < headerFocusManagers.length; i++) {
            if (headerFocusManagers[i].toggle && headerFocusManagers[i].toggle.isSet) {
                return true;
            }
        }
    }

    return false;
}
